import React from 'react';
import { Route } from 'react-router';

import { MenuSection } from './MenuSection';
import { BookSection } from './BookSection';
import { ContactSection } from './ContactSection';
import { PopupSection } from './PopupSection';
import { largeMargin } from '../margins';
import { Section } from './Section';

let Scroller;
// eslint-disable-next-line no-undef
if (process.env.SERVER) {
  // eslint-disable-next-line no-undef
  Scroller = require('./SSRScroller').SSRScroller;
} else {
  // eslint-disable-next-line no-undef
  Scroller = require('./Scroller').Scroller;
}

export const Posts = ({ posts, phoneNumber }) => (
  <Route
    path="/:section?"
    render={({ match }) =>
      posts.map(
        post =>
          post.sectionType === 'popup' ? (
            <PopupSection key={post.id} {...post} allPosts={posts} />
          ) : (
            <Scroller
              key={post.id}
              css={`
                margin-bottom: ${largeMargin};

                &:last-child {
                  margin-bottom: 0;
                }
              `}
              scrollTo={post.slug === match.params.section}
              render={scrollToRef =>
                getPostSection(
                  post,
                  scrollToRef,
                  posts,
                  phoneNumber,
                  post.slug === match.params.section
                )
              }
            />
          )
      )
    }
  />
);

function getPostSection(post, scrollToRef, allPosts, phoneNumber, active) {
  switch (post.sectionType) {
    case 'menu':
      return (
        <MenuSection active={active} scrollToRef={scrollToRef} {...post} />
      );
    case 'book':
      return (
        <BookSection active={active} scrollToRef={scrollToRef} {...post} />
      );
    case 'contact':
      return (
        <ContactSection
          scrollToRef={scrollToRef}
          {...post}
          allPosts={allPosts}
          phoneNumber={phoneNumber}
          active={active}
        />
      );
    default:
      return (
        <Section
          heading={post.heading}
          content={post.content}
          marketing={post.marketingActivated && post.marketing}
          image={post.bigImage}
          scrollToRef={scrollToRef}
        />
      );
  }
}



// WEBPACK FOOTER //
// ./app/components/Posts.js